import Stage1 from "./stage1";
import Stage2 from "./stage2";
import Stage3 from "./stage3";
import Stage4 from "./stage4";
import Stage5 from "./stage5";

const Stages = [Stage1, Stage2, Stage3, Stage4, Stage5];
export default Stages;
